import React from "react";

export default function Button(props) {
    const { permission, disabled } = props;

    const disable = (permission && permission === "disable") || disabled ? true : false;
    const hidden = permission && permission === "hidden" ? true : false;

    return hidden === true ? null : (
        <button {...props} disabled={disable}>
            {props.children}
        </button>
    );
};